import { useState } from "react";

import RaindropButton, {
  ButtonStyle,
} from "../raindrop-button/raindrop-button.tsx";

import { fetchGenericEndpoint } from "../../services/api-raindrop";

const EndpointHitter = ({
  title,
  description = "",
  endpoint,
  setResponse,
  method,
}) => {
  const [isRunning, setIsRunning] = useState(false);

  const onClick = () => {
    setIsRunning(true);
    setResponse(null);

    fetchGenericEndpoint({ endpoint, method })
      .then((response) => {
        setResponse(JSON.stringify(response, null, 4));
      })
      .catch((response) => {
        setResponse(JSON.stringify(response));
      })
      .finally(() => {
        setIsRunning(false);
      });
  };

  return (
    <div
      className={`flex flex-col text-left gap-2 p-4 rounded-lg border w-full max-w-lg
      dark:bg-color-dark-background-secondary bg-color-background-secondary
      dark:border-color-dark-border-secondary border-color-border-secondary
      `}
    >
      <div className="flex flex-col">
        <div className="font-bold">{title}</div>
        <div className="flex flex-row gap-2 text-xs items-center">
          <div className="font-bold text-color-dark-text-tertiary">
            {method}
          </div>
          <div className=" dark:text-color-text-secondary">{endpoint}</div>
        </div>

        <div className="text-sm dark:text-color-dark-text-tertiary py-2">
          {description}
        </div>
      </div>
      <div className="flex flex-row w-full items-end justify-end">
        <RaindropButton
          title={"Run"}
          onClick={onClick}
          icon={"fa-play"}
          isLoading={isRunning}
          style={ButtonStyle.Secondary}
        />
      </div>
    </div>
  );
};

export default EndpointHitter;
